var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.798897879
  }, /*#__PURE__*/React.createElement("g", {
    id: "slozka-list-190415",
    transform: "translate(-256.000000, -1066.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(138.000000, 974.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "003-folder",
    transform: "translate(118.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.996,6.4 L21.6,6.4 L21.6,3.8928 C21.6,3.29 21.1096,2.8 20.5072,2.8 L10.606,2.8 L8.606,0 L1.0928,0 C0.4904,0 0,0.4904 0,1.0928 L0,18.5676 L0.0024,18.5676 C0.0004,18.7928 0.0704,19.0132 0.2112,19.1976 C0.4072,19.4536 0.704,19.6 1.026,19.6 L18.9296,19.6 C19.392,19.6 19.7992,19.2884 19.9096,18.8748 L24,7.6596 L24,7.5888 C24,6.9 23.5776,6.4 22.996,6.4 Z M0.8,1.0928 C0.8,0.9312 0.9316,0.8 1.0928,0.8 L8.194,0.8 L10.194,3.6 L20.5068,3.6 C20.6684,3.6 20.7996,3.7312 20.7996,3.8928 L20.7996,6.4 L5.0924,6.4 C5.0348,6.4 4.9776,6.4048 4.922,6.4144 C4.5328,6.4796 4.2092,6.7636 4.1128,7.1248 L0.8,16.1596 L0.8,1.0928 Z M19.1476,18.6332 C19.1212,18.7312 19.0312,18.8 18.9296,18.8 L1.026,18.8 C0.9288,18.8 0.872,18.7444 0.8468,18.7112 C0.8216,18.6784 0.7828,18.6088 0.7976,18.548 L4.874,7.3668 C4.9004,7.2688 4.9904,7.2 5.092,7.2 L21.6,7.2 L22.996,7.2 C23.148,7.2 23.1868,7.4184 23.1968,7.5276 L19.1476,18.6332 Z",
    id: "slozka-nadpis"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIconDark);
export default __webpack_public_path__ + "static/media/FolderIconDark.94caef859207e5fd1c3f41f68c25cff4.svg";
export { ForwardRef as ReactComponent };